import Link from "next/link";
import { Button } from "shared/components/atoms/Button";
import { BaseModal } from "shared/components/organisms/modal/BaseModal";
import { Paths } from "utils/routes";

export const AlertInAvailableMenuModal = () => {
  return (
    <BaseModal
      title="申し訳ございません"
      subTitle={`このメニューは現在お申し込みいただけません🙇‍♀️\n恐れ入りますが他のメニューをご検討ください`}
      dismissable={false}
    >
      <Link href={Paths.home()}>
        <a>
          <Button tw="bg-gradient-theme-to-l w-full">トップページに戻る</Button>
        </a>
      </Link>
    </BaseModal>
  );
};
